// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-alerts {
  border-radius: 10px;
  padding: 16px;
  margin-top: 8rem;
}

.campaign-alerts .alert-box {
  padding: 1rem;
  border-radius: 12px;
  background-color: #ffffff;
  width: 100%;
  /* height: 100%; */
  min-height: 240px;
  position: relative;
}

.campaign-alerts .alert-box .heading {
  color: #60a999 !important;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px dotted rgb(210, 203, 203);
  width: max-content;
  margin: 0;
  width: 100%;
}

.campaign-alerts .alert-box .value {
  color: black !important;
  font-weight: 800;
  font-size: 30px;
}
.campaign-alerts .alert-box .loading {
  padding: 10px 5px;
}
.campaign-alerts .alert-box .loading .icon {
  font-size: 24px;
  color: rgb(107 114 128 / 1) !important;
}

.campaign-alerts .alert-box p {
  color: rgb(107 114 128 / 1) !important;
}

.campaign-alerts .alert-box .btn-div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.campaign-alerts .alert-box .btn-div .average-btn-size {
  position: absolute;
  bottom: 15px;
}
.average-btn-size {
  display: flex;
  min-width: 100px;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/campaignAlerts.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".campaign-alerts {\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 8rem;\n}\n\n.campaign-alerts .alert-box {\n  padding: 1rem;\n  border-radius: 12px;\n  background-color: #ffffff;\n  width: 100%;\n  /* height: 100%; */\n  min-height: 240px;\n  position: relative;\n}\n\n.campaign-alerts .alert-box .heading {\n  color: #60a999 !important;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 1px dotted rgb(210, 203, 203);\n  width: max-content;\n  margin: 0;\n  width: 100%;\n}\n\n.campaign-alerts .alert-box .value {\n  color: black !important;\n  font-weight: 800;\n  font-size: 30px;\n}\n.campaign-alerts .alert-box .loading {\n  padding: 10px 5px;\n}\n.campaign-alerts .alert-box .loading .icon {\n  font-size: 24px;\n  color: rgb(107 114 128 / 1) !important;\n}\n\n.campaign-alerts .alert-box p {\n  color: rgb(107 114 128 / 1) !important;\n}\n\n.campaign-alerts .alert-box .btn-div {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.campaign-alerts .alert-box .btn-div .average-btn-size {\n  position: absolute;\n  bottom: 15px;\n}\n.average-btn-size {\n  display: flex;\n  min-width: 100px;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
